<template>
<div style="overflow-y: scroll;position: relative;" :style="{height:height}">

  <div style="position: sticky;left: 0;top: 0;z-index: 2;display: flex;flex-direction: row;">
    <el-input
      size="mini"
      placeholder="输入关键字进行过滤"
      v-model="filterText">
    </el-input>
    <el-button v-if="isCheckbox&&is_submit" size="mini" @click="submit">确 认</el-button>
  </div>

  <el-tree
    ref="tree"
    :props="props"
    :load="loadNode"
    node-key="house_id"
    lazy
    :highlight-current="true"
    :expand-on-click-node="false"
    :filter-node-method="filterNode"
    @node-click="nodeClick"
    @check="check"
    :default-checked-keys="default_checked_keys"
    :show-checkbox="isCheckbox">
  </el-tree>
</div>
</template>

<script>
export default {
  name: "ProjectTree",
  props:{
    is_submit:{type:Boolean,default:()=>true},
    isCheckbox:{type:Boolean,default:()=>false},
    project_id: {type:Number|String,default:()=>0},
    checked_keys:{type:String|Number,default:()=>''},
    height:{type:String,default:()=>"300px"}
  },
  data() {
    return {
      props: {
        label: 'house_name',
        children: 'zones',
        isLeaf: 'leaf'
      },
      filterText:"",
      default_checked_keys:[],
      check_nodes:[]
    };
  },
  mounted() {

  },
  methods: {
    loadNode(node, resolve) {
      const that=this;
      if (node.level === 0) {
        that.getData(0,ret=>{
          resolve(ret);
          that.reSelect();
          that.$emit('onNodeList',ret)
        })
        return false;
      }
      that.getData(node.data.house_id,ret=>{
        resolve(ret);
      })
    },
    getData(id,callback){
      ERP.getRequest({
        url:"admin/Project/getParentSon",
        data:{
          id:id,
          project_id:this.project_id,
        }
      },ret=>{
        if(ret.code){
          callback(ret.data);
        }else {
          callback([])
        }
      })
    },
    reSelect(){
      if(this.checked_keys){
        let checked_keys=((this.checked_keys||"")+"").split(',').map(id=>id*1);
        if(checked_keys.length){
          this.default_checked_keys=checked_keys
        }
      }
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.ancestor_name.indexOf(value) !== -1;
    },
    nodeClick(data){
      if(!this.isCheckbox){
        this.$emit('onNode',data)
      }
    },
    check(data){
      if(this.isCheckbox){
        this.check_nodes=this.$refs.tree.getCheckedNodes()
        if(!this.is_submit){
          this.$emit('onNode',this.check_nodes)
        }
      }
    },
    submit(){
      this.$emit('onNode',this.check_nodes)
    }
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    }
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Admin/EnergyConsumption/components/meter/components/ProjectTree.vue